export default __webpack_public_path__ + "static/media/bgKevlar.d9df7433.jpg";